import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './WidgetContainer.module.css';

/**
 * WidgetContainer - A reusable container for dashboard widgets
 * Handles loading, error, and no-data states consistently across all widgets
 */
function WidgetContainer({ 
  children, 
  loading = false, 
  error = null, 
  noData = false,
  noDataMessage = 'No data available',
  className = '',
}) {
  // Show loading state
  if (loading) {
    return (
      <div className={`${styles.container} ${className}`}>
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className={`${styles.container} ${className}`}>
        <div className={styles.error}>
          <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
            <line x1="12" y1="8" x2="12" y2="12" strokeWidth="2" />
            <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" />
          </svg>
          <span>{typeof error === 'string' ? error : 'Error loading data'}</span>
        </div>
      </div>
    );
  }

  // Show no data state
  if (noData) {
    return (
      <div className={`${styles.container} ${className}`}>
        <div className={styles.noData}>
          <svg className={styles.noDataIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
            <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" />
            <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" />
          </svg>
          <span>{noDataMessage}</span>
        </div>
      </div>
    );
  }

  // Show content
  return (
    <div className={`${styles.container} ${className}`}>
      {children}
    </div>
  );
}

WidgetContainer.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  noData: PropTypes.bool,
  noDataMessage: PropTypes.string,
  className: PropTypes.string,
};

WidgetContainer.defaultProps = {
  children: null,
  loading: false,
  error: null,
  noData: false,
  noDataMessage: 'No data available',
  className: '',
};

export default WidgetContainer;

